import Box, { type BoxProps } from '@mui/material/Box';
import { createElement } from 'react';
import { type IconName, iconPaths } from './icon-paths';

export type { IconName };

interface IconProps extends Omit<BoxProps<'svg'>, 'children'> {
  name: IconName;
  size?: number;
  strokeWidth?: number;
  /** Adds the prototype's spin animation (loader icons). */
  spin?: boolean;
}

/** Stroke icon from the prototype's icon set. Inherits `color` from its parent. */
export function Icon({ name, size = 20, strokeWidth = 1.8, spin, sx, ...props }: IconProps) {
  return (
    <Box
      component="svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
      sx={[
        { display: 'block', flex: 'none' },
        !!spin && { animation: 'mdSpin .9s linear infinite' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    >
      {iconPaths[name].map(([tag, attrs], i) =>
        // Static, index-stable icon geometry.
        createElement(tag, { key: i, ...attrs }),
      )}
    </Box>
  );
}
